import { render, staticRenderFns } from "./ApprovalChatDlg.vue?vue&type=template&id=1f9f60f1&scoped=true&"
import script from "./ApprovalChatDlg.vue?vue&type=script&lang=ts&"
export * from "./ApprovalChatDlg.vue?vue&type=script&lang=ts&"
import style0 from "./ApprovalChatDlg.vue?vue&type=style&index=0&id=1f9f60f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9f60f1",
  null
  
)

export default component.exports